module.exports = __webpack_public_path__ + "images/category_lp/smartphone/store_images/4_2835b09c0cb03cd0ee1eac68e3cbfef2.png";